import {
  ConversationCustomerDto,
  ConversationDto,
  ConversationState,
} from "../../../dto/conversation";

export const formatDateTime = (iso?: string | null): string => {
  if (!iso) return "";
  const normalized = iso.endsWith("Z") || iso.includes("+") ? iso : iso + "Z";
  const d = new Date(normalized);

  const time = new Intl.DateTimeFormat("it-IT", {
    hour: "2-digit",
    minute: "2-digit",
  }).format(d); // "17:03"

  const month = new Intl.DateTimeFormat("it-IT", {
    month: "short",
  }).format(d); // "mar"

  const day = new Intl.DateTimeFormat("it-IT", {
    day: "2-digit",
  }).format(d); // "12"

  return `${time} | ${month} ${day}`;
};

export const getCustomerDisplay = (c: ConversationCustomerDto) => ({
  code: (c.code ?? "").trim(),
  fullName: `${c.name ?? ""} ${c.surname ?? ""}`.trim(),
});

function formatCustomer(c: ConversationCustomerDto) {
  const fullName = `${c.name ?? ""} ${c.surname ?? ""}`.trim();
  const code = (c.code ?? "").trim();
  return { fullName, code };
}

export function buildTitleFromConversation(convo: ConversationDto): string {
  const customers = convo.customers ?? [];

  if (customers.length === 1) {
    const { code, fullName } = formatCustomer(customers[0]);

    if (code && fullName) return `${code} - ${fullName}`;
    if (fullName) return fullName;
    if (code) return code;
  }

  return (convo.customerPhone ?? "").trim() || "Numero sconosciuto";
}

export const hasWarningForConversation = (convo: ConversationDto): boolean =>
  convo.state === ConversationState.Pending;

export function extractE164(phone?: string | null): string {
  const raw = (phone ?? "").trim();
  if (!raw) return "";

  const afterColon = raw.includes(":") ? raw.split(":").pop() ?? raw : raw;

  const cleaned = afterColon.replace(/[^\d+]/g, "");
  return cleaned;
}
